<template>
  <section class="flickity-carousel">
    <h4 :class="titleStyles">{{ carouselTitle }}</h4>
    <flickity ref="flickity" :options="flickityOptions">
      <!-- todo: Need help for this-->
      <div v-for="(item) in items" :key="item.uuid" class="carousel-cell" :class="{'video': itemHasVideo(item)}">
        <CarouselItemComponent :item="item"/>
      </div>
    </flickity>
  </section>
</template>
<script>
import Flickity from 'vue-flickity'
import CarouselItemComponent from "@/components/home/CarouselItemComponent"

export default {
  name: 'CarouselList',
  components: {Flickity, CarouselItemComponent},
  props: {
    items: Array,
    carouselTitle: {type: String, default: 'Title'},
    titleStyles: {type: String, default: 'font-bold text-2xl mb-4'}
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        freeScroll: false,
        wrapAround: false,
        contain: true,
        cellAlign: 'left',
        imagesLoaded: true
      }
    }
  },

  methods: {
    itemHasVideo(item) {
      return item.files.find(file => file.mime_type.startsWith('video/'))
    }
  }
}
</script>

<style>
  .flickity-carousel .flickity-viewport {
    overflow: visible !important;
  }
</style>
